import React from 'react';
import Confetti from 'react-dom-confetti';

const SingleCheckBox = props => {
  const { name, label, value } = props;
  function handleChange(e) {
    props.onChange(e);
  }
  return (
    <label>
      <input
        type="checkbox"
        name={name}
        onChange={handleChange}
        checked={value}
      />
      {label}
      <Confetti active={value} />
    </label>
  );
};

export default SingleCheckBox;
